import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { CommunityActivityType } from 'types/communities';

import ActivityBubble from './ActivityBubble';
import { ACTIVITY_DIRECTION_TYPE } from './constants';

type ActivityItemProps = {
  activity: CommunityActivityType;
  communityId?: number;
  showRenderedBody: boolean;
  onToggleRenderedBody: () => void;
  onActivityUpdated?: () => void | Promise<unknown>;
};

const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;

  &.direction-inbound {
    justify-content: flex-start;
  }

  &.direction-outbound {
    justify-content: flex-end;
  }

  &.direction-unknown {
    justify-content: center;
  }

  &.direction-internal {
    justify-content: center;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 1px;
      background: linear-gradient(90deg, transparent 0%, var(--line-gray) 18%, var(--line-gray) 82%, transparent 100%);
      transform: translateY(-50%);
    }

    > * {
      position: relative;
      z-index: 1;
    }
  }
`;

const ActivityItem = ({
  activity,
  communityId,
  showRenderedBody,
  onToggleRenderedBody,
  onActivityUpdated,
}: ActivityItemProps) => {
  return (
    <Container
      className={classNames({
        'direction-inbound': activity.direction_type === ACTIVITY_DIRECTION_TYPE.INBOUND,
        'direction-outbound': activity.direction_type === ACTIVITY_DIRECTION_TYPE.OUTBOUND,
        'direction-unknown': activity.direction_type === ACTIVITY_DIRECTION_TYPE.UNKNOWN,
        'direction-internal': activity.direction_type === ACTIVITY_DIRECTION_TYPE.INTERNAL,
      })}
    >
      <ActivityBubble
        activity={activity}
        communityId={communityId}
        showRenderedBody={showRenderedBody}
        onToggleRenderedBody={onToggleRenderedBody}
        onActivityUpdated={onActivityUpdated}
      />
    </Container>
  );
};

export default ActivityItem;
